export default __webpack_public_path__ + "a308a2d88dd2ad595a074b1183e0ed37.png";